import {
  Building,
  AngleDown,
  AngleLeft,
  AngleRight,
  CalendarMonth,
  MapPin,
  ArrowRight,
  ChevronUp,
  ChevronDown,
  Close,
  ClipboardList,
  UsersGroup,
  Edit,
  CheckCircle
} from "flowbite-react-icons/outline";

const icons = {
  Building: Building,
  AngleDown: AngleDown,
  AngleLeft: AngleLeft,
  AngleRight: AngleRight,
  CalendarMonth: CalendarMonth,
  MapPin: MapPin,
  ArrowRight: ArrowRight,
  ChevronUp: ChevronUp,
  ChevronDown: ChevronDown,
  Close: Close,
  ClipboardList: ClipboardList,
  UsersGroup: UsersGroup,
  Edit: Edit,
  CheckCircle: CheckCircle,
} as const;

export type IconType = keyof typeof icons;

interface IProps {
  iconType?: IconType;
  className?: string;
  iconClassName?: string;
}

const FlowbiteIconComponent = ({
  iconType,
  className = "",
  iconClassName = "",
}: IProps) => {
  if (!iconType) return null;

  const IconComponent = icons[iconType];

  if (!IconComponent) return null;

  return (
    <div className={`ml-1 ${className}`}>
      <IconComponent className={iconClassName} />
    </div>
  );
};

export default FlowbiteIconComponent